import { GET_MY_PROFILE_SUCCESS, LOG_OUT } from './auth.types';

const initialState = {
  myProfile: null,
  accessToken: null,
};

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_MY_PROFILE_SUCCESS:
      return {
        ...state,
        myProfile: action.payload,
      };
    case LOG_OUT:
      return initialState;
    default:
      return state;
  }
};
